<div class="reset-container">
  @if(!RequestSent){
    <form (ngSubmit)="submitResetPasswordRequest()">
      <h2 class="text-header">Glömt lösenordet?</h2>
      <p class="text-subtext">
        Ange din epostadress för att ta emot en länk för att återställa lösenordet.
      </p>

      <div class="input-and-error-wrapper">
        <label class="field-label" for="email">Epostadress</label>

        <div class="input-wrapper">
          <img src="../../assets/icons/mail.svg" alt="" class="input-icon-left" />
          <input
            required
            type="email"
            [email]="email !== ''"
            class="input-field"
            id="email"
            placeholder="Ange din epostadress"
            [(ngModel)]="email"
            name="email"
            #resetRequestControl="ngModel"
            />
            @if ((loading || requestSuccess) && !requestError) {
              <div
                class="status-icon"
                >
                <img
                  src="../../assets/icons/Loading.svg"
                  class="status-img"
              [ngClass]="{
                'loading': loading,
                'success': requestSuccess
              }"
                  alt="status"
                  />
                </div>
              }
            </div>

            <div class="errorMsgPlaceholder">
              @if(requestError){
                <p class="error-msg">
                  <img src="../../assets/icons/error.svg" alt="" class="error-icon" />
                  {{errorMsg}}
                </p>
              }
            </div>
          </div>

          <button type="submit" class="submit-btn" [disabled]="btnDisabled || !resetRequestControl.dirty">
            Skicka mejl
          </button>
        </form>

        }@else {
        <div class="success-container">
          <h2 class="text-header">Kolla din epost</h2>

          <p class="text-subtext">
            Klicka på den <strong>länk</strong> som skickats till
            <strong>{{email}}</strong> för att verifiera epostadressen.
            Om du inte hittar länken, kolla gärna i spam.
          </p>

          <div class="resend-wrapper">
            <p class="text-subtext d-inline">Har du inte fått mejlet? </p>
            <a (click)="submitResetPasswordRequest()" class="resend-link">
              Skicka om mejl.
            </a>
          </div>
        </div>
      }